<script lang="ts">
	import { CaretDown, IconSprites } from "@ishavskraft/shared";

	let { children }: { children?: import("svelte").Snippet } = $props();
</script>

<!-- Sprite registration scoped to the spotprisen family (covers
     /spotprisen/* + /spotprisen/historikk/*). The CaretDown symbol is only
     used by the AreaSelect dropdown on these surfaces, so it doesn't need
     to live in the global root-layout sprite sheet. -->
<IconSprites icons={[CaretDown]} />

<div class="spotprisen-layout">
	{@render children?.()}
</div>

<style lang="postcss">
	:global(body):has(.spotprisen-layout) {
		--triangle-size: min(100vw, 500px);
		--triangle-rotate: 135deg;
		--triangle-scale-x: 1;
		--triangle-translate-x: min(-20vw, -100px);
		--triangle-translate-y: min(-40vw, -100px);
	}

	@media (--tablet) {
		:global(body):has(.spotprisen-layout) {
			--triangle-rotate: -50deg;
			--triangle-translate-x: max(-20px, -5vw);
			--triangle-translate-y: min(750px, 40vw);
		}
	}
</style>
